import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { backendShape, url } from "../..";
import { Column, Row, Container } from "../Grid";
import { withBackend, withConfiguration } from "../../context";
import Loader from "../Loader";

type Props = {
  backend?: backendShape;
  configuration: {
    appCannyBoardToken?: string;
  };
};

export function Feedback({ backend, configuration }: Props) {
  const [loading, setLoading] = useState(true);

  /* istanbul ignore next */
  React.useEffect(() => {
    const loadCanny = async () => {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const cannyToken = await backend
        .get("/canny_token")
        // eslint-disable-next-line no-console
        .catch(console.log);
      // eslint-disable-next-line
      (function (w, d, i, s) {
        function l() {
          if (!d.getElementById(i)) {
            // eslint-disable-next-line
            var f = d.getElementsByTagName(s)[0],
              e = d.createElement(s);
            // eslint-disable-next-line
            ((e as $TSFixMe).type = "text/javascript"),
              ((e as $TSFixMe).async = !0),
              ((e as $TSFixMe).src = "https://canny.io/sdk.js"),
              // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
              f.parentNode.insertBefore(e, f);
          }
        }
        // eslint-disable-next-line
        if ("function" != typeof (w as $TSFixMe).Canny) {
          // eslint-disable-next-line
          var c = function () {
            (c as $TSFixMe).q.push(arguments); // eslint-disable-line
          };
          // eslint-disable-next-line
          ((c as $TSFixMe).q = []),
            // eslint-disable-next-line
            ((w as $TSFixMe).Canny = c),
            // eslint-disable-next-line
            "complete" === d.readyState
              ? l()
              : (w as $TSFixMe).attachEvent
                ? (w as $TSFixMe).attachEvent("onload", l)
                : w.addEventListener("load", l, !1);
        }
      })(window, document, "canny-jssdk", "script");
      // @ts-expect-error TS(2304) FIXME: Cannot find name 'Canny'.
      // eslint-disable-next-line no-undef
      Canny("render", {
        boardToken: configuration.appCannyBoardToken,
        basePath: url("/feedback"),
        ssoToken: cannyToken,
      });
      setLoading(false);
    };
    /* istanbul ignore next */
    loadCanny();
  }, []);

  return (
    <Container>
      <Row>
        <Column>
          <h1>
            <FormattedMessage id="feedback.header" />
          </h1>
          <Loader id="feedback-loader" loading={loading} />
          <div data-canny />
        </Column>
      </Row>
    </Container>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<P... Remove this comment to see the full error message
export default withBackend(withConfiguration(Feedback));
